export default {
      id: "ic-eye-open-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-eye-open-usage",
      toString: function () {
        return this.url;
      }
    }